import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent } from '../components/ui/card';
import { MapPin, ArrowLeft, Mail, Lock, Loader2, Shield } from 'lucide-react';
import { toast } from 'sonner';

const ADMIN_EMAIL = 'admin@taptag.al';
const ADMIN_PASSWORD = 'TapTag2024Admin!';

const TAPTAG_LOGO = "https://customer-assets.emergentagent.com/job_726f4ba1-c975-4f39-ba02-ad3131a12031/artifacts/hgye1jst_IMG_0895%20%281%29.PNG";

const AdminLogin = () => {
  const navigate = useNavigate();
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      toast.error('Plotëso të gjitha fushat');
      return;
    }

    setLoading(true);
    
    // Simulate loading
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    if (email === ADMIN_EMAIL && password === ADMIN_PASSWORD) {
      localStorage.setItem('taptag_admin', 'true');
      toast.success('Mirë se erdhe, Admin!');
      navigate('/admin/panel');
    } else {
      toast.error('Email ose fjalëkalimi i gabuar');
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white flex items-center justify-center p-4">
      {/* Background */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div className="floating-orb w-96 h-96 bg-violet-500/20 -top-48 -left-48 animate-float" />
        <div className="floating-orb w-64 h-64 bg-cyan-500/20 bottom-20 right-20 animate-float" style={{ animationDelay: '2s' }} />
        <div className="absolute inset-0 grid-pattern opacity-30" />
      </div>

      <div className="relative z-10 w-full max-w-md">
        {/* Back Link */}
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors mb-8"
          data-testid="back-home-link"
        >
          <ArrowLeft className="w-4 h-4" />
          Kthehu në faqen kryesore
        </Link>

        {/* Card */}
        <Card className="bg-white border-slate-200 shadow-xl">
          <CardContent className="p-8">
            {/* Logo */}
            <div className="flex items-center justify-center gap-3 mb-8">
              <img 
                src={TAPTAG_LOGO}
                alt="TAPTAG Logo"
                className="w-16 h-16 rounded-full object-cover shadow-lg"
              />
            </div>

            <h1 className="text-2xl font-bold text-slate-900 text-center mb-2" data-testid="admin-login-title">
              Admin Panel
            </h1>
            <p className="text-slate-500 text-center mb-8">
              Hyr me kredencialet e administratorit
            </p>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="space-y-2">
                <Label htmlFor="email" className="text-slate-700">Email i Adminit</Label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                  <Input
                    id="email"
                    type="email"
                    placeholder="admin@taptag.al"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="pl-11 h-12 border-slate-300 focus:border-violet-500"
                    data-testid="admin-email-input"
                  />
                </div>
              </div>

              <div className="space-y-2">
                <Label htmlFor="password" className="text-slate-700">Fjalëkalimi</Label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                  <Input
                    id="password"
                    type="password"
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="pl-11 h-12 border-slate-300 focus:border-violet-500"
                    data-testid="admin-password-input"
                  />
                </div>
              </div>

              <Button
                type="submit"
                disabled={loading}
                className="w-full h-12 bg-gradient-to-r from-violet-600 to-purple-600 text-white rounded-xl text-lg font-semibold shadow-lg hover:shadow-xl transition-all"
                data-testid="admin-login-btn"
              >
                {loading ? (
                  <>
                    <Loader2 className="w-5 h-5 animate-spin mr-2" />
                    Duke hyrë...
                  </>
                ) : (
                  'Hyr si Admin'
                )}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AdminLogin;
